import React, { useEffect, useState } from 'react';
import { getCapitalLisSingle } from '../../../actions/capital';
import { validateEnablePayCapital } from '../../payment/PaidUpCapital';

const PayButton = ({ message, loaderPay, goToPaidUp }) => {
    const [paidUpAmountPaid, setPaidUpAmountPaid] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const resp = await getCapitalLisSingle(message.data.company);
                setPaidUpAmountPaid(resp?.paidUpAmountPaid);
            } catch (error) {
                console.error("Failed to fetch paidUpAmountPaid", error);
            }
            setLoading(false);
        };

        if (message?.data?.company) {
            fetchData();
        }
    }, [message]);

    const isPaid = paidUpAmountPaid !== null && validateEnablePayCapital(message.data, paidUpAmountPaid);

    const handleClick = () => {
        goToPaidUp()
    };

    if (loading) {
        return <button className="pay-now-btn" disabled>Loading...</button>;
    }

    return (
        <button
            type="button"
            disabled={isPaid}
            className="pay-now-btn"
            onClick={handleClick}
        >
            {loaderPay && <i className="animateSpin fa-solid fa-circle-notch"></i>}{' '}
            {isPaid ? 'Paid' : 'Pay now'}
        </button>
    );
};

export default PayButton;
